export default [
  {
    name: 'SystemAction',
    values: {
      name: '',
      type: '',
      subType: '',
      tag: '',
      level: '',
      prompt: '',
      fieldToElicit: '',
    },
  },
  {
    name: 'Target',
    values: {
      name: '',
      status: '',
    },
  },
  {
    name: 'SubTarget',
    values: {
      name: '',
      status: '',
    },
  },
  {
    name: 'Session',
    values: {
      appName: '',
      channel: '',
      line: '',
      dnis: '',
    },
  },
  {
    name: 'Intent',
    values: {
      name: '',
      status: '',
    },
  },
];
